import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { storageAdapter } from '@bettercampus/global/runtime';

type AuthState = 'loading' | 'authed' | 'unauthed';

function getNotificationStatus(): 'unsupported' | 'granted' | 'denied' | 'default' {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}

export function HomePage() {
  const [authState, setAuthState] = useState<AuthState>('loading');
  const notifStatus = getNotificationStatus();

  useEffect(() => {
    storageAdapter.get('local', ['auth']).then(result => {
      const token = result?.auth?.access_token;
      setAuthState(token ? 'authed' : 'unauthed');
    });
  }, []);

  if (authState === 'loading') {
    return (
      <div className="app-shell" style={{ flexDirection: 'column' }}>
        <div className="install-card">
          <img src="/icon-192.png" alt="" className="install-logo" width={96} height={96} />
          <p className="install-description">Loading...</p>
        </div>
      </div>
    );
  }

  if (authState === 'unauthed') {
    return (
      <div
        className="app-shell"
        style={{ flexDirection: 'column', justifyContent: 'flex-start', paddingTop: '3rem' }}
      >
        <div className="install-card">
          <img src="/icon-192.png" alt="" className="install-logo" width={96} height={96} />
          <h1 className="install-title">BetterCampus</h1>
          <p className="install-description">
            You're not signed in. Open the BetterCampus extension and click{' '}
            <strong>Install Mobile App</strong> to link this device.
          </p>
          <Link
            to="/verify"
            className="btn btn-install"
            style={{ textDecoration: 'none', marginTop: '0.5rem' }}
          >
            Enter code manually
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div
      className="app-shell"
      style={{ flexDirection: 'column', justifyContent: 'flex-start', paddingTop: '3rem' }}
    >
      <div className="install-card">
        <img src="/icon-192.png" alt="" className="install-logo" width={96} height={96} />
        <h1 className="install-title">BetterCampus</h1>
        <p className="install-badge">You are connected!</p>

        {notifStatus === 'denied' && (
          <p style={{ marginTop: '1rem', fontSize: '0.8125rem', color: '#ef4444' }}>
            Notifications are blocked. Enable them in your browser settings for reminders to work.
          </p>
        )}
        {notifStatus === 'default' && (
          <p style={{ marginTop: '1rem', fontSize: '0.8125rem', color: '#d97706' }}>
            Notifications aren't enabled yet. You'll be prompted when needed, or enable them in
            browser settings.
          </p>
        )}
        {notifStatus === 'unsupported' && (
          <p style={{ marginTop: '1rem', fontSize: '0.8125rem', color: '#6b7280' }}>
            This browser doesn't support notifications.
          </p>
        )}

        <div
          style={{
            marginTop: '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            width: '100%',
          }}
        >
          <Link to="/notifications" className="btn btn-install" style={{ textDecoration: 'none' }}>
            Notifications
          </Link>
          <button
            type="button"
            className="btn btn-secondary"
            style={{ width: '100%', justifyContent: 'center' }}
            onClick={() => {
              storageAdapter.set('local', { auth: null });
              setAuthState('unauthed');
            }}
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
